import { render, staticRenderFns } from "./IntroView.vue?vue&type=template&id=53c666bb&scoped=true&"
import script from "./IntroView.vue?vue&type=script&lang=js&"
export * from "./IntroView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c666bb",
  null
  
)

export default component.exports